export const defaultTokens = {
  applyBackendColAndStyle: false,
  constColours: {
    primary: {
      main: "#ED6C02",
      light: "#FF9800",
      dark: "#E65100",
      contrastText: "#FFFFFF",
      bg: "#FFF3E0",
    },
    // primary: {
    //   main: "#1976D2",
    //   light: "#42A5F5",
    //   dark: "#1565C0",
    //   contrastText: "#FFFFFF",
    //   bg: "#E3F2FD",
    // },
    secondary: {
      main: "#333333",
      light: "#E0E0E0",
      dark: "#1A1A1A",
      contrastText: "#FFFFFF",
      bg: "#F7F7F7",
    },
    secondary2: {
      main: "#6B7280",
      m: "#333",
      light: "#E5E7EB",
      dark: "#374151",
      contrastText: "#FFFFFF",
      bg: "#F9FAFB",
    },
    secondary3: {
      main: "#9C27B0",
      light: "#BA68C8",
      dark: "#7B1FA2",
      contrastText: "#FFFFFF",
      bg: "#F3E5F5",
    },
    info: {
      main: "#0288D1",
      light: "#03A9F4",
      dark: "#01579B",
      contrastText: "#FFFFFF",
      bg: "#E1F5FE",
    },
    success: {
      main: "#2E7D32",
      light: "#4CAF50",
      dark: "#1B5E20",
      contrastText: "#FFFFFF",
      bg: "#E8F5E9",
    },
    // warning: {
    //   main: "#ED6C02",
    //   light: "#FF9800",
    //   dark: "#E65100",
    //   contrastText: "#FFFFFF",
    //   bg: "#FFF3E0",
    // },
    error: {
      main: "#D32F2F",
      light: "#EF5350",
      dark: "#C62828",
      contrastText: "#FFFFFF",
      bg: "#FFEBEE",
    },
    disabled: {
      main: "#9E9E9E",
      light: "#c5c2c2ff",
      contrastText: "#FFFFFF",
      bg: "#F5F5F5",
    },
    ghost: {
      main: "#d2d0d0ff",
      light: "#E0E0E0",
      dark: "#b4b3b3ff",
      contrastText: "#0d0d0dff",
      bg: "transparent",
    },
    colorsList: {
      white: "#FFFFFF"
    }
  },
  font: {
    fontW: {
      fontW500: 500,
      fontW600: 600,
      fontW700: 700,
    },
    fontSz: {
      fontSz24: "1.5rem",
      fontSz20: "1.25rem",
      fontSz18: "1.125rem",
      fontSz16: "1rem",
      fontSz14: ".875rem",
    },
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    fontSize: 14,
  },
  borderSz: {
    default: "1px solid ",
    border1px: "1px solid ",
    border2px: "2px solid ",
  },
  borderRd: {
    default: "8px", // This will be updated based on backend received rectangular or round and will be used in styling
    rectangular: "0px", // Just for giving 0px for rectangular
    round: "8px", // Just for giving 10px for round and can be updated
    borderRd4px: "4px",
    borderRd8px: "8px",
    borderRd16px: "16px",
  },
};
